import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPlusCircleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <circle cx={14} cy={14} r={13} stroke="currentColor" strokeWidth={2} />
    <rect width={2} height={14} x={13} y={7} fill="currentColor" rx={1} />
    <rect
      width={2}
      height={14}
      x={21}
      y={13}
      fill="currentColor"
      rx={1}
      transform="rotate(90 21 13)"
    />
  </svg>
);
export default SvgPlusCircleIcon;
